export default "GoodLock åbnede i juni 2020.\n\nBemærk: Betaling foregår kontant eller med MobilePay.";